import React, {useState} from 'react';
import axios from 'axios';
import {Button} from 'primereact/button';
import {ConfirmDialog} from 'primereact/confirmdialog';
import {hasRole} from '../../../../utils/hasRole';

export default function EmployeeDeactivateButton({employeeId, employee, onDeactivated, t}) {
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [deactivating, setDeactivating] = useState(false);
  const eligible = employee?.active === true && Array.isArray(employee.employments) &&
    employee.employments.length === 0 && hasRole('ROLE_EMPLOYEE_WRITE');

  const deactivate = () => {
    if (deactivating || !eligible) return;
    setDeactivating(true);
    axios({
      method: 'post',
      url: process.env.REACT_APP_API_HOST + '/api/v2/employee/' + employeeId + '/deactivate',
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('userToken'),
        'App-Network': localStorage.getItem('networkId'),
      },
    }).then(() => {
      onDeactivated();
      window.App.toastShow('success', t('employeeDeactivateSuccess'));
      window.App.setState({
        rerenderEmployeeList: !window.App.state.rerenderEmployeeList,
        rerenderEmployeeShow: !window.App.state.rerenderEmployeeShow,
      });
    }).catch(error => {
      window.App.toastShow('error', t('error'), error.toString(), '', error.response);
    }).finally(() => setDeactivating(false));
  };

  if (!eligible) return null;

  return <>
    <Button type="button" label={t('employeeDeactivate')} icon="pi pi-ban"
            className="p-button-danger p-ml-2" loading={deactivating} disabled={deactivating}
            onClick={() => setConfirmVisible(true)}/>
    <ConfirmDialog visible={confirmVisible} onHide={() => setConfirmVisible(false)}
                   header={t('employeeDeactivate')} message={t('employeeDeactivateConfirm')}
                   icon="pi pi-exclamation-triangle" acceptLabel={t('employeeDeactivate')}
                   rejectLabel={t('cancel')} accept={deactivate}/>
  </>;
}
